(function(){
  function money(cents, fmt){
    fmt = fmt || '${{amount}}';
    var n = (cents / 100);
    function grp(x, dec, ts, ds){
      var p = x.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      return grp(n, 2, ',', '.');
    });
  }

  function init(root){
    if (root.dataset.avsReady) return;
    root.dataset.avsReady = '1';

    /* gallery */
    var slides = root.querySelectorAll('.avs-slide');
    var thumbs = root.querySelectorAll('.avs-thumb');
    var dots = root.querySelectorAll('.avs-dots span');
    var active = 0;
    function show(i){
      if (!slides.length) return;
      active = (i + slides.length) % slides.length;
      slides.forEach(function(s, n){ s.classList.toggle('is-active', n === active); });
      thumbs.forEach(function(t, n){ t.classList.toggle('is-active', n === active); });
      dots.forEach(function(d, n){ d.classList.toggle('is-active', n === active); });
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ show(parseInt(t.dataset.index, 10)); }); });
    root.querySelectorAll('[data-slide]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(active + parseInt(b.getAttribute('data-slide'), 10)); }); });
    var stage = root.querySelector('[data-stage]'), sx = null;
    if (stage && slides.length > 1){
      stage.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function(e){
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(active + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }

    /* variants: size + bundle, priced from the real variants so page = cart = checkout */
    var vEl = root.querySelector('[data-avs-variants]');
    var cEl = root.querySelector('[data-avs-config]');
    var variants = [], cfg = { packIndex: -1 };
    try { variants = JSON.parse(vEl.textContent); } catch (e) {}
    try { cfg = JSON.parse(cEl.textContent); } catch (e) {}
    var input = root.querySelector('[data-variant-input]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-avs-group]'));
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');

    function selection(){
      var sel = [];
      groups.forEach(function(g){
        var r = g.querySelector('input:checked');
        sel[parseInt(g.getAttribute('data-avs-group'), 10)] = r ? r.value : null;
      });
      return sel;
    }
    function find(sel){
      for (var i = 0; i < variants.length; i++){
        var v = variants[i], ok = true;
        for (var j = 0; j < v.options.length; j++){ if (sel[j] != null && v.options[j] !== sel[j]){ ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function qtyOf(val){ var q = parseInt(String(val), 10); return q > 0 ? q : 1; }

    function refreshPacks(sel){
      var pi = cfg.packIndex;
      if (pi == null || pi < 0) return;
      var g = root.querySelector('[data-avs-group="' + pi + '"]');
      if (!g) return;
      var inputs = g.querySelectorAll('input');
      if (!inputs.length) return;
      var firstVal = inputs[0].value;
      var sSel = sel.slice(); sSel[pi] = firstVal;
      var single = find(sSel);
      var best = null, bestPct = 0;
      inputs.forEach(function(inp){
        var label = inp.closest('label');
        var pSel = sel.slice(); pSel[pi] = inp.value;
        var v = find(pSel), q = qtyOf(inp.value);
        var priceEl = label.querySelector('[data-price]'), fullEl = label.querySelector('[data-full]');
        var saveEl = label.querySelector('[data-save]'), noteEl = label.querySelector('[data-note]');
        var oldPop = label.querySelector('.avs-pop'); if (oldPop) oldPop.remove();
        if (!v){ inp.disabled = true; label.classList.add('is-disabled'); if (priceEl) priceEl.textContent = ''; return; }
        inp.disabled = !v.available; label.classList.toggle('is-disabled', !v.available);
        if (priceEl) priceEl.textContent = money(v.price, cfg.money);
        var full = single ? single.price * q : v.price;
        var save = full - v.price;
        var pct = save > 0 ? Math.floor(save * 100 / full) : 0;
        if (fullEl){ fullEl.textContent = money(full, cfg.money); fullEl.style.display = save > 0 ? '' : 'none'; }
        if (saveEl){ saveEl.textContent = 'Save ' + pct + '%'; saveEl.style.display = save > 0 ? '' : 'none'; }
        if (noteEl) noteEl.textContent = q > 1 ? money(Math.round(v.price / q), cfg.money) + ' each' : (v.available ? 'Just for you' : 'Sold out');
        if (pct > bestPct){ bestPct = pct; best = label; }
      });
      if (best){
        var pop = document.createElement('span');
        pop.className = 'avs-pop';
        pop.textContent = 'Best value';
        best.appendChild(pop);
      }
    }

    function update(push){
      var sel = selection();
      groups.forEach(function(g){ g.querySelectorAll('label').forEach(function(l){ var i = l.querySelector('input'); l.classList.toggle('is-selected', !!(i && i.checked)); }); });
      refreshPacks(sel);
      var v = find(sel);
      if (!v) return;
      if (input) input.value = v.id;
      root.querySelectorAll('[data-atc-price]').forEach(function(p){ p.textContent = money(v.price, cfg.money); });
      if (atc){ atc.disabled = !v.available; }
      if (atcLabel){ atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      root.querySelectorAll('[data-sticky-add]').forEach(function(b){ b.disabled = !v.available; });
      if (push){ try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {} }
    }
    groups.forEach(function(g){ g.addEventListener('change', function(){ update(true); }); });
    if (variants.length) update(false);

    /* delivery estimate */
    var eta = root.querySelector('[data-eta]');
    if (eta){
      var addBiz = function(n){ var d = new Date(); while (n > 0){ d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
      var p = parseInt(eta.dataset.proc, 10) || 0, a = parseInt(eta.dataset.min, 10) || 0, b = parseInt(eta.dataset.max, 10) || a;
      if (a > 0){
        var f = { month: 'short', day: 'numeric' };
        eta.querySelector('[data-eta-range]').textContent = addBiz(p + a).toLocaleDateString('en-US', f) + ' – ' + addBiz(p + b).toLocaleDateString('en-US', f);
        eta.hidden = false;
      }
    }

    /* sticky bar */
    var form = root.querySelector('form.avs-form');
    var bar = root.querySelector('[data-sticky]');
    if (bar && atc && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
    }
    var stickyAdd = root.querySelector('[data-sticky-add]');
    if (stickyAdd && form && atc){
      stickyAdd.addEventListener('click', function(){
        if (form.requestSubmit) { form.requestSubmit(atc); } else { atc.click(); }
      });
    }
    var buy = root.querySelector('.avs-buy');
    root.querySelectorAll('[data-scroll-buy]').forEach(function(el){
      el.addEventListener('click', function(e){
        if (!buy) return;
        e.preventDefault();
        buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
  function boot(){ document.querySelectorAll('.avs').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();